import { LoggerInstance } from "@vfit/shared/providers";
export var handleSuccess = function(data) {
    // TData
    LoggerInstance.debug("DATA HANDLE SUCCESS GENERIC", data);
};
export var handleError = function(error) {
    // TError
    LoggerInstance.error("ERROR HANDLER GENERIC", error);
};
